import { useState, useEffect, useCallback } from 'react';

const useDebouncedSearch = (onSearch = null, delay = 5000) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');
  const [debounceTimer, setDebounceTimer] = useState(null);

  // Handle search input change
  const handleSearchChange = useCallback((value) => {
    setSearchTerm(value);

    // Clear existing timer
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }

    // Set new timer for debounced search
    const newTimer = setTimeout(() => {
      setDebouncedSearchTerm(value);
      
      // Call the onSearch callback if provided
      if (onSearch && typeof onSearch === 'function') {
        onSearch(value);
      }
    }, delay);

    setDebounceTimer(newTimer);
  }, [debounceTimer, delay, onSearch]);

  // Clear search
  const clearSearch = useCallback(() => {
    setSearchTerm('');
    setDebouncedSearchTerm('');
    if (debounceTimer) {
      clearTimeout(debounceTimer);
    }
  }, [debounceTimer]);

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (debounceTimer) {
        clearTimeout(debounceTimer);
      }
    };
  }, [debounceTimer]);

  return {
    searchTerm,
    debouncedSearchTerm,
    handleSearchChange,
    clearSearch
  };
};

export default useDebouncedSearch;
